<template>
    <div class="parpopup" v-if="dataVal.flag">
        <div class="par">
            <div class="par_head">
                <div class="par_head_close"></div>
                <div class="par_head_title">参数</div>
                <div class="par_head_close" @click="handleRefund">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="par_cont">
                <div class="par_info">
                    <div class="par_info_item">
                        <div class="par_info_item_l">显示名称：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.name" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item">
                        <div class="par_info_item_l">英文名称：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.name_en" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item">
                        <div class="par_info_item_l">描 述：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.describe" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item">
                        <div class="par_info_item_l">英文描述：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.describe_en" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <!-- <div class="par_info_item">
                        <div class="par_info_item_l">长 度：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.param_length" placeholder="请输入"></el-input>
                        </div>
                    </div> -->
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">U I D：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.galileoUID" placeholder="请输入Galileo制造商与型号UID"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">灯具最大亮度：</div>
                        <div class="par_info_item_r1">
                            <el-input type="number" v-model="parameterObj.maxlight" @input="handleMaxlightInput"
                                placeholder="请输入Galileo制造商与型号UID"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">是否支持蓝牙：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="isMesh" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">是否支持DMX：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="isDMX" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 3">
                        <div class="par_info_item_l">是否支持蛋格：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="isDG" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div>
                    <!-- <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">是否支持CCT调节：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="param_iscct" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">CCT最小值：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.param_cctmin" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">CCT最大值：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.param_cctmax" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">是否支持GM调节：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="param_isgm" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div> -->
                </div>
                <div class="par_info">
                    <!-- <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">是否支持HSI调节：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="param_ishsi" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">是否支持RGB调节：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="param_isrgb" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">是否支持像素控制：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="param_ispixel" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">X方向最大分区数：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.param_xmax" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">Y方向最大分区数：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.param_ymax" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <div class="par_info_item" v-if="dataVal.type == 2">
                        <div class="par_info_item_l">多分区XY方向分区数：</div>
                        <div class="par_info_item_r1">
                            <el-input v-model="parameterObj.param_xy" placeholder="请输入"></el-input>
                        </div>
                    </div> -->
                    <div class="par_info_item">
                        <div class="par_info_item_l">状 态：</div>
                        <div class="par_info_item_r1">
                            <el-switch v-model="status" active-color="#e64a19" inactive-color="#e5e5e5">
                            </el-switch>
                        </div>
                    </div>
                    <!-- <div class="par_info_item">
                        <div class="par_info_item_l">上传文件：</div>
                        <div class="par_info_item_r1">
                            <el-upload class="upload-demo" :action="uploadfile" :on-remove="handleRemove" :limit="1"
                                :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess2"
                                :file-list="imageslist2">
                                <el-button>点击上传</el-button>
                            </el-upload>
                        </div>
                    </div> -->
                    <div class="par_info_item">
                        <div class="par_info_item_l">缩略图：</div>
                        <div class="par_info_item_r3">
                            <div class="par_info_item_r_tip" v-if="urlarr.length == 0">
                                <i class="el-icon-download"></i>
                                <span>上传图片</span>
                            </div>
                            <img :src="urlarr[0]" alt="" v-if="urlarr.length > 0" srcset="">
                            <div class="cen_body_mtr_img_unload">
                                <el-upload class="avatar-uploader" :action="uploadfile" :headers="headers"
                                    accept="image/jpg,image/jpeg,image/png" :file-list="imageslist"
                                    :before-upload="beforeAvatarUpload" :show-file-list="true"
                                    :on-success="handleAvatarSuccess" :on-progress="handleUploadProgress">
                                    <img class="avatar">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                            <div class="cen_body_mtr_img_pro"
                                v-if="imageslist.length > 0 && percentage && percentage != 100">
                                <el-progress type="circle" :percentage="percentage"></el-progress>
                            </div>
                            <div class="cen_body_mtr_img_close" v-if="urlarr[0]" @click="imageslist = []; urlarr = []">
                                <i class="el-icon-close"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="par_btn">
                <div class=" par_btn_cancel" @click="handleRefund">取消</div>
                <div class="par_btn_cancel par_btn_submit" @click="handleSubmit">提交</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modelParameter',
    props: ['dataVal'],
    data() {
        return {
            urls: localStorage.getItem('baseURL'),
            uploadfile: localStorage.getItem("baseURL") + "/api/admin/index/uploadfile",

            imageslist: [], //缩略图
            imageslist2: [], // 文件
            urlarr: [],
            headers: {
                token: localStorage.token,
            },
            imguploagsuccess: false,//是否处于上传图片中
            percentage: 0,

            checkList: [],
            rotatelist: [{
                id: '1',
                name: '俯仰角'
            }, {
                id: '2',
                name: '水平角'
            }, {
                id: '3',
                name: '翻滚角'
            }],
            status: true,
            isMesh: true,
            isDMX: true,
            isDG: true,
            param_iscct: true,
            param_isgm: true,
            param_ishsi: true,
            param_isrgb: true,
            param_ispixel: true,
            parameterObj: {
                id: '', //id 编辑必填
                filename: '', //文件名称
                fileurl: '', //文件所在路径
                thumbnail: '', //缩略图
                name: '', //显示名称
                name_en: '', //英文显示名称
                describe: '', //描述
                describe_en: '', //英文描述
                param_iscct: '',//是否支持CCT调节 1是 0否
                param_cctmin: '',//CCT最小值
                param_cctmax: '',//CCT最大值
                param_isgm: '',//是否支持GM调节
                param_ishsi: '',//是否支持HSI调节
                param_isrgb: '',//是否支持RGB调节
                param_ispixel: '',//是否支持像素控制
                param_xmax: '',//X方向最大分区数
                param_ymax: '',//Y方向最大分区数
                param_xy: '',//多分区XY方向分区数
                status: '', //状态：0=隐藏，1=显示
                isMesh: '', //是否支持蓝牙
                galileoUID: '', //Galileo制造商与型号UID，
                maxlight: '', //灯具最大亮度
                isDMX: '', //是否支持DMX
                isDG: '', //是否支持蛋格
            }
        }
    },
    methods: {
        //取消弹窗
        handleRefund() {
            console.log(this.parameterObj)
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("parameterCal", data);
        },
        handleSubmit() {
            if (this.imguploagsuccess) {
                this.$message.warning("文件正在上传中，请稍后");
                return false
            }
            let obj = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                parameterObj: this.parameterObj
            }
            this.$emit("parameterCal", obj);
        },
        handleMaxlightInput(value) {
            this.parameterObj.maxlight = value.replace(/\D/g, '');
        },
        checkboxChange(e) {
            // if (e.length == 0) {
            //     this.parameterObj.param_rotate = this.checkList.toString()
            // } else {
            //     this.checkList = e.splice(e.length - 1)
            //     this.parameterObj.param_rotate = Number(this.checkList.toString())
            // }
            this.parameterObj.param_rotate = this.checkList.toString()
        },
        handleRemove(file, fileList) {
        },
        handleUploadProgress(event, file, fileList) {
            this.imguploagsuccess = true;
            let filearr = fileList
            filearr[0].percentage = Math.round(Number(event.percent));
            this.imageslist = filearr;
            this.percentage = Math.round(Number(event.percent));
        },
        beforeAvatarUpload(file) {
            this.imguploagsuccess = true;
            return true;
        },
        //图片上传
        handleAvatarSuccess(response, file, fileList) {
            this.imguploagsuccess = false
            if (response.code == 1) {
                this.urlarr = []
                this.urlarr.push(this.urls + response.data.file);
                fileList.forEach((element, i) => {
                    if (element.response && element.response.code == 0) {
                        fileList.splice(i, 1);
                    }
                });
                this.imageslist = fileList;
                this.imageslist[0].url = this.urlarr[0];
                this.$message({
                    type: "success",
                    message: "图片上传成功",
                });
            } else {
                fileList.forEach((element, i) => {
                    if (element.response && element.response.code == 0) {
                        fileList.splice(i, 1);
                    }
                });
                this.imageslist = fileList;
                this.$message({
                    type: "success",
                    message: response.msg,
                });
            }
        },
        //文件上传
        handleAvatarSuccess2(response, file, fileList) {
            this.imguploagsuccess = false
            if (response.code == 1) {
                fileList.forEach((element, i) => {
                    if (element.response && element.response.code == 0) {
                        fileList.splice(i, 1);
                    }
                });
                this.imageslist2 = fileList;
                this.imageslist2[0].url = this.urls + response.data.file;

                this.$message({
                    type: "success",
                    message: "图片上传成功",
                });
            } else {
                fileList.forEach((element, i) => {
                    if (element.response && element.response.code == 0) {
                        fileList.splice(i, 1);
                    }
                });
                this.imageslist2 = fileList;
                this.$message({
                    type: "success",
                    message: response.msg,
                });
            }
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    this.parameterObj = {
                        id: newVal.data.id,
                        filename: newVal.data.filename ? newVal.data.filename : '',
                        fileurl: newVal.data.fileurl ? newVal.data.fileurl : '',
                        thumbnail: newVal.data.thumbnail ? newVal.data.thumbnail : '',
                        name: newVal.data.name ? newVal.data.name : '',
                        name_en: newVal.data.name_en ? newVal.data.name_en : '',
                        describe: newVal.data.describe ? newVal.data.describe : '',
                        describe_en: newVal.data.describe_en ? newVal.data.describe_en : '',
                        param_iscct: Number(newVal.data.param_iscct),
                        param_cctmin: newVal.data.param_cctmin ? newVal.data.param_cctmin : '',
                        param_cctmax: newVal.data.param_cctmax ? newVal.data.param_cctmax : '',
                        param_isgm: Number(newVal.data.param_isgm),
                        param_ishsi: Number(newVal.data.param_ishsi),
                        param_isrgb: Number(newVal.data.param_isrgb),
                        param_ispixel: Number(newVal.data.param_ispixel),
                        param_xmax: newVal.data.param_xmax ? newVal.data.param_xmax : '',
                        param_ymax: newVal.data.param_ymax ? newVal.data.param_ymax : '',
                        param_xy: newVal.data.param_xy ? newVal.data.param_xy : '',
                        status: Number(newVal.data.status),
                        isMesh: Number(newVal.data.isMesh),
                        isDMX: Number(newVal.data.isDMX),
                        isDG: Number(newVal.data.isDG),
                        galileoUID: newVal.data.galileoUID ? newVal.data.galileoUID : '',
                        maxlight: newVal.data.maxlight ? newVal.data.maxlight : ''
                    }
                    // this.checkList = []
                    // if (newVal.data.param_rotate) {
                    //     this.checkList = newVal.data.param_rotate.split(',')
                    // }

                    this.urlarr = []
                    if (newVal.data.thumbnail) {
                        let imgarr = []
                        imgarr.push({
                            name: '',
                            url: this.urls + newVal.data.thumbnail,
                            percentage: 100,
                            size: 0,
                            status: "success",
                            uid: 1,
                            response: { data: { file: newVal.data.thumbnail, backname: '' } }
                        })
                        this.imageslist = imgarr
                        this.urlarr.push(this.urls + newVal.data.thumbnail)
                    } else {
                        this.imageslist = []
                    }
                    this.imageslist2 = []
                    if (newVal.data.fileurl && newVal.data.filename) {
                        this.imageslist2.push({
                            name: newVal.data.filename,
                            url: this.urls + newVal.data.fileurl,
                            percentage: 100,
                            size: 0,
                            status: "success",
                            uid: 1,
                            response: { data: { file: newVal.data.fileurl, backname: newVal.data.filename } }
                        })
                    }

                    this.param_iscct = newVal.data.param_iscct == 1 ? true : false;
                    this.status = newVal.data.status == 1 ? true : false;
                    this.isMesh = newVal.data.isMesh == 1 ? true : false;
                    this.isDMX = newVal.data.isDMX == 1 ? true : false;
                    this.isDG = newVal.data.isDG == 1 ? true : false;
                    this.param_isgm = newVal.data.param_isgm == 1 ? true : false;
                    this.param_ishsi = newVal.data.param_ishsi == 1 ? true : false;
                    this.param_isrgb = newVal.data.param_isrgb == 1 ? true : false;
                    this.param_ispixel = newVal.data.param_ispixel == 1 ? true : false;
                }
            },
            deep: true
        },
        param_iscct: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.param_iscct = 1
                } else {
                    this.parameterObj.param_iscct = 0
                }
            }
        },
        param_isgm: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.param_isgm = 1
                } else {
                    this.parameterObj.param_isgm = 0
                }
            }
        },
        param_ishsi: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.param_ishsi = 1
                } else {
                    this.parameterObj.param_ishsi = 0
                }
            }
        },
        param_isrgb: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.param_isrgb = 1
                } else {
                    this.parameterObj.param_isrgb = 0
                }
            }
        },
        param_ispixel: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.param_ispixel = 1
                } else {
                    this.parameterObj.param_ispixel = 0
                }
            }
        },
        isMesh: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.isMesh = 1
                } else {
                    this.parameterObj.isMesh = 0
                }
            },
            deep: true
        },
        isDMX: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.isDMX = 1
                } else {
                    this.parameterObj.isDMX = 0
                }
            },
            deep: true
        },
        isDG: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.isDG = 1
                } else {
                    this.parameterObj.isDG = 0
                }
            },
            deep: true
        },
        status: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.parameterObj.status = 1
                } else {
                    this.parameterObj.status = 0
                }
            },
            deep: true
        },
        imageslist: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.parameterObj.thumbnail = newVal[0].response.data.file
                } else {
                    this.parameterObj.thumbnail = ''
                }
            },
            deep: true
        },
        imageslist2: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.parameterObj.fileurl = newVal[0].response.data.file
                    this.parameterObj.filename = newVal[0].response.data.backname
                } else {
                    this.parameterObj.fileurl = ''
                    this.parameterObj.filename = ''
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss">
.parpopup {
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .par {
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .par_head {
            width: 100%;
            height: 50px;
            background-color: #f6f6f6;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;

            .par_head_close {
                width: 20px;
                height: 20px;
                cursor: pointer;

                .el-icon-close {
                    font-size: 20px;
                    color: #999999;
                    cursor: pointer;
                }
            }

            .par_head_title {
                font-size: 16px;
                color: #333333;
                cursor: default;
            }
        }

        .par_cont {
            width: 100%;
            display: flex;

            .par_info {
                width: 100%;
                display: flex;
                flex-direction: column;
                padding: 0 30px;
                margin-top: 10px;

                .par_info_item {
                    width: 100%;
                    display: flex;
                    margin-top: 20px;

                    .par_info_item_l {
                        width: 170px;
                        height: 32px;
                        line-height: 32px;
                        font-size: 14px;
                        letter-spacing: 1px;
                        color: #333333;
                        text-align: right;
                        padding-right: 10px;
                    }

                    .par_info_item_r1 {
                        width: 300px;
                        display: flex;
                        align-items: center;
                    }

                    .par_info_item_r2 {
                        width: 300px;

                        /deep/.is-checked {
                            .el-checkbox__inner {
                                background-color: #e64a19;
                                border-color: #e64a19;
                            }
                        }

                        /deep/.el-checkbox-group {
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                        }

                        /deep/.el-checkbox {
                            margin: 6px 0;

                            .el-checkbox__input {
                                .el-checkbox__inner {
                                    width: 20px;
                                    height: 20px;
                                    border-radius: 4px;

                                    &::after {
                                        height: 10px;
                                        left: 7px;
                                    }
                                }
                            }
                        }
                    }

                    .par_info_item_r3 {
                        width: 300px;
                        height: 200px;
                        background-color: #f9f9f9;
                        border-radius: 4px;
                        border: solid 1px #dbdbdb;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        z-index: 101;

                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }

                        .par_info_item_r_tip {
                            display: flex;
                            align-items: center;

                            .el-icon-download {
                                font-size: 16px;
                                color: #999999;
                            }

                            span {
                                font-size: 14px;
                                color: #999999;
                                margin-left: 10px;
                            }
                        }

                        .cen_body_mtr_img_unload {
                            width: 100%;
                            height: 100%;
                            opacity: 0;
                            position: absolute;
                            z-index: 102;

                            /deep/.avatar-uploader {
                                width: 100%;
                                height: 100%;

                                .el-upload {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                        }

                        .cen_body_mtr_img_pro {
                            width: 100%;
                            height: 100%;
                            background-color: rgba(0, 0, 0, 0.5);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                            top: 0;
                            left: 0;
                            z-index: 103;

                            /deep/.el-progress {
                                width: 108px;
                                height: 108px;
                                padding: 10px;

                                .el-progress-circle {
                                    width: 100% !important;
                                    height: 100% !important;
                                }
                            }
                        }

                        .cen_body_mtr_img_close {
                            width: 20px;
                            height: 20px;
                            background-color: #e64a19;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                            top: 0;
                            right: 0;
                            z-index: 104;
                            cursor: pointer;

                            .el-icon-close {
                                line-height: 20px;
                                color: #fff;
                                font-size: 16px;
                            }
                        }
                    }

                    .par_info_item_r4 {
                        width: 300px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        /deep/.el-input {
                            width: 120px;
                            height: 32px;

                            .el-input__inner {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        span {
                            width: 24px;
                            height: 1px;
                            background-color: #333333;
                        }
                    }
                }
            }
        }

        .par_btn {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 30px 37px 26px 37px;

            .par_btn_cancel {
                width: 80px;
                height: 32px;
                font-size: 14px;
                color: #606266;
                background-color: #ffffff;
                border-radius: 4px;
                border: solid 1px #dbdbdb;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 10px;
                cursor: pointer;
            }

            .par_btn_submit {
                color: #ffffff;
                border: solid 1px #e64a19;
                background-color: #e64a19;
            }
        }
    }
}
</style>